// @flow
import { destroy, get, post, put } from "./helpers/fetch";
import join from "url-join";
import { SLOW_REQUEST_THRESHOLD } from "../constants/urls";

export default class AccountDAO {
  accessToken: string;
  fastServerUrl: string;
  fastAccountUrl: string;
  logging: Object;

  constructor(
    accessToken: string,
    fastServerUrl: string,
    fastAccountUrl: string,
    logger: Object
  ) {
    this.accessToken = accessToken;
    this.fastServerUrl = fastServerUrl;
    this.fastAccountUrl = fastAccountUrl;
    this.logging = { logger, loggingThreshold: SLOW_REQUEST_THRESHOLD };
  }

  addNewAccountUser(user) {
    return post({
      accessToken: this.accessToken,
      url: join(this.fastAccountUrl, "accountusers", "v2"),
      params: user,
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  updateAccountUser(user, userId) {
    return put({
      accessToken: this.accessToken,
      url: join(this.fastAccountUrl, "accountusers", "v2", userId),
      params: user,
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  deleteAccountUser(userId) {
    return destroy({
      accessToken: this.accessToken,
      url: this.getUrl(join("accountusers", userId)),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  fetchAccountUsers(accountId) {
    return get({
      accessToken: this.accessToken,
      url: join(this.fastAccountUrl, "accountusers", "v2"),
      params: { accountId, filterActiveSeats: false, includeExpired: false },
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  promoteUser(id) {
    return post({
      accessToken: this.accessToken,
      url: this.getUrl(join("accountusers", id, "promote")),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  demoteUser(id) {
    return post({
      accessToken: this.accessToken,
      url: this.getUrl(join("accountusers", id, "demote")),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  fetchAccountSummary(id) {
    return get({
      accessToken: this.accessToken,
      url: join(this.fastAccountUrl, "account", id),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  updateAccountSummary(account, id) {
    return put({
      accessToken: this.accessToken,
      url: join(this.fastAccountUrl, "account", id),
      params: account,
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  getIsUpgradeEligible() {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl("/recharge/upgrade/eligible"),
      // url: join(
      //   'https://backend.fastmodelsports.com',
      //   '/recharge/upgrade/eligible',
      // ),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  getRechargeUpgradePayload() {
    return get({
      accessToken: this.accessToken,
      url: this.getUrl("/recharge/upgrade/link"),
      // url: join(
      //   'https://backend.fastmodelsports.com',
      //   '/recharge/upgrade/link',
      // ),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  upgradeSubscription(sku, externalVariantId) {
    return post({
      accessToken: this.accessToken,
      url: this.getUrl(
        `/recharge/upgrade/subscription?sku=${sku}&externalVariantId=${externalVariantId}`
      ),
      // url: join(
      //   'https://backend.fastmodelsports.com',
      //   `/recharge/upgrade/subscription?sku=${sku}&externalVariantId=${externalVariantId}`,
      // ),
      headers: { "Content-Type": "application/json" },
      ...this.logging,
    });
  }

  getUrl(endpoint: string) {
    return join(this.fastServerUrl, endpoint);
  }
}
